import { captureFunnelError } from 'helpers/captureFunnelError'
import { FunnelErrorCode } from 'helpers/funnelErrors'

import { ALL_SUPPORTED_LOCALES } from 'root-constants'

export const loadLanguageResources = async (lng: string) => {
  try {
    const lang = lng.toLowerCase()

    if (ALL_SUPPORTED_LOCALES.includes(lang)) {
      return (await import(`assets/i18n/${lang}.json`)).default
    }

    return (await import('assets/i18n/en.json')).default
  } catch (error) {
    console.error(`Failed to load language ${lng}:`, error)
    captureFunnelError(FunnelErrorCode.FUNNEL_LANGUAGE_LOAD_FAILED, error, {
      extra: { requestedLanguage: lng },
    })
    throw error
  }
}
